














import {Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { UserProfile } from "@api/models/UserProfile";
import UsersList from "@share/common/users-list/UsersList.vue";
import { getElementOffsetWidth } from "@service/helpers/domHelper";
import { getHowMuchWillFit } from "@service/helpers/elementSizeHelper";
import IsParticipantsLimited from '@mixins/isParticipantsLimited';

import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";

import {groupFilter} from "@api/helpers/groupFilter";
import { Location } from 'vue-router';

@Component({
    components: { UsersList }
})
export default class UsersWatching extends Mixins(IsParticipantsLimited) {

    @Prop({ required: true}) onlineUserIds: number[];
    @Prop({ required: true }) onlineUsersCount: number;

    usersWatching: UserProfile[] = [];
    usersProfilesListData: {profiles: UserProfile[]; count: number; take: number} = { profiles: [], count: 0, take: 34 };
    participantsMoreAmount = 0;
    userIconSize = 36;

    userRepository: UserRepository;
    moreAmountLink: Location | null = null;

    created() {
        this.userRepository = this.$repositories.get(RepositoryFabric.USER);
    }

    mounted() {
        this.getUsersProfilesList();

        this.moreAmountLink = {
            name: "Participants",
            params: {
                onlineOnly: "true"
            }
        }
    }

    setParticipantsList(userProfilesList: any, count = 0, take = 34) {
        const length = userProfilesList?.length;
        if(length) {

            const participantsListElement = ((this.$refs['participantsList'] as Vue)?.$el as HTMLElement);
            const containerWidth = getElementOffsetWidth(participantsListElement);

            if(!containerWidth) {
                return
            }

            const howMuchWillFit = getHowMuchWillFit((containerWidth - this.userIconSize), this.userIconSize + 6);

            //поместились все
            if(howMuchWillFit >= count && howMuchWillFit <= take) {
                this.usersWatching = userProfilesList;
                this.participantsMoreAmount = 0;
                return;
            }

            //count больше или равно чем take, т.е. есть пользователи которых не можем отрендерить
            if(count > take) {
                //показываем всех кого можно отрендерить

                if(howMuchWillFit >= length) {
                    // обрезаем тех кого не можем отрендерить
                    this.participantsMoreAmount = count - length;
                }
                else {
                    //обрезаем и тех кого не можем отрендерить и тех кто не помещается физически
                    this.participantsMoreAmount = count - howMuchWillFit;
                }

                this.usersWatching = userProfilesList.slice(0, howMuchWillFit);
            }
            else {

                //count меньше чем take, всех пользователей можем отрендерить
                if(howMuchWillFit < length && howMuchWillFit > 0) {
                    //если не помещаются в контейнер то обрезаем
                    this.participantsMoreAmount = length - howMuchWillFit;
                }
                else if(howMuchWillFit <= 0) {
                    //если не помещается ни один элемент
                    this.participantsMoreAmount = length;
                }

                this.usersWatching = userProfilesList.slice(0, howMuchWillFit);
            }

        }
        else {
            this.usersWatching = [];
        }
    }

    private async fetchUserProfiles(userIds: Array<number>, take = 34) {
        const groupIds = this.participantsGroupIds();

        const query = {
                where: {
                    userId: {
                        $in: userIds
                    },
                    ...groupFilter(groupIds)
                },
                include: ["id", "userId", "lastName", "firstName", "photoFileId", "company", "position"],
                take: take
            };

        return await this.userRepository.profilesWithCount(query);
    }

    @Watch('onlineUserIds')
    async getUsersProfilesList() {
        const randomIds = [...this.onlineUserIds].sort(() => 0.5 - Math.random());
        let responseObject: {profiles: UserProfile[]; count: number} = { profiles: [], count: 0 };
        const take = 34;

        if(randomIds.length > 0) {
            responseObject = await this.fetchUserProfiles(randomIds.splice(0, 34), take);
        }

        this.usersProfilesListData = { profiles: responseObject.profiles, count: responseObject.count, take }

        this.setParticipantsList(responseObject.profiles, this.onlineUsersCount, take);
    }

    updateList() {
        this.setParticipantsList(this.usersProfilesListData.profiles, this.onlineUsersCount, this.usersProfilesListData.take);
    }

}
